import { useState, useEffect } from "react";
const useInputFocus = () => {
  const [el, setElement] = useState(null), [focused, setFocused] = useState(!1);
  return useEffect(() => {
    const target = el;
    if (!target) return;
    const ac = new AbortController(), { signal } = ac, root = target.getRootNode(), setFocus = () => {
      setFocused(!0);
    }, removeFocus = () => {
      setFocused(!1);
    }, handleFocusIn = () => {
      setFocus();
    }, handleFocusOut = (e) => {
      target.contains(e.relatedTarget) || removeFocus();
    }, handlePointerDown = (e) => {
      target.contains(e.target) || removeFocus();
    };
    target.addEventListener("focusin", handleFocusIn, { signal }), target.addEventListener("focusout", handleFocusOut, { signal }), root.addEventListener("pointerdown", handlePointerDown, {
      signal
    });
    const input = target.querySelector("input");
    return root.activeElement === input && setFocus(), () => {
      ac.abort();
    };
  }, [el]), { setElement, focused };
};
export {
  useInputFocus
};
//# sourceMappingURL=useInputFocus.js.map
